import { render, staticRenderFns } from "./RipaActionsTaken.vue?vue&type=template&id=8c65c202"
import script from "./RipaActionsTaken.vue?vue&type=script&lang=js"
export * from "./RipaActionsTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports